import { CheckBoxWithLabelWidget } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../codegen/Localize';
import { ISettingsFormScope, SettingsFormService } from '../../settings/directives/tbSettingsCoordinator';
import { ISiteAdminSettings } from '../../settings/types/ISiteSettingsForSiteAdmin';
import { getAppStore } from '../AppStore';
import { SessionServerSelectors } from '../selectors/SessionInfoSelectors';
import { ServiceLocator } from '../ServiceLocator';
import { SiteSettingsStyles } from './styles/SiteSettingsStyles';

interface NotifySiteAdminsOnThrottleSettingProps {
    siteAdminSettings: ISiteAdminSettings;
}

interface NotifySiteAdminsOnThrottleSettingState {
    isEnabled: boolean;
    initialIsEnabled: boolean;
}

/**
 * @deprecated This has been ported over to the React settings under NotifySiteAdminsOnThrottleSection.tsx
 * and can be removed when siteSettingsForSiteAdminForm.pug is removed.
 */
export class NotifySiteAdminsOnThrottleSetting extends React.PureComponent<NotifySiteAdminsOnThrottleSettingProps, NotifySiteAdminsOnThrottleSettingState> {
    private shouldRender: boolean;

    constructor(props: NotifySiteAdminsOnThrottleSettingProps) {
        super(props);
        this.shouldRender = SessionServerSelectors.isTimeBasedGovernanceEnabled(getAppStore().getState());
        if (!this.shouldRender) {
            return; // No need to initialize
        }

        const isEnabled = !!this.props.siteAdminSettings?.notifySiteAdminsOnThrottleEnabled;
        this.state = {
            isEnabled: isEnabled,
            initialIsEnabled: isEnabled,
        };

        const formService = ServiceLocator.get<SettingsFormService>('SettingsFormService');
        const $q = ServiceLocator.get<ng.IQService>('$q');
        const formState: ISettingsFormScope = {
            formController: {
                $pristine: true,
                $dirty: false,
                $valid: true,
                $invalid: true,
                $submitted: false,
                $error: {},
                $addControl: () => { },
                $removeControl: () => { },
                $setValidity: () => { },
                $setDirty: () => { },
                $setPristine: () => { },
                $setSubmitted: () => { },
                $setUntouched: () => { },
                $commitViewValue: () => { },
                $rollbackViewValue: () => { },
            },
            cancel: () => this.setState({
                isEnabled: this.state.initialIsEnabled,
            }),
            // Annoyingly save is called after the update occurs
            // so we have to update the shared object that holds
            // the form state
            save: () => {
                this.setState({
                    initialIsEnabled: this.state.isEnabled,
                });
                return $q.resolve();
            },

            // "Optional" but actually required
            isBusy: () => false,
            isFormUnchanged: () => {
                return this.state.isEnabled === this.state.initialIsEnabled;
            },
            isValid: () => true,
        };
        formService.registerFormStateByName(formState, 'Notify Site Admin On Throttle Settings');
    }

    public render() {
        if (!this.shouldRender) {
            return null;
        }
        return <>
            <div style={SiteSettingsStyles.HeaderStyle}>{Messages.notifySiteAdminsOnThrottleSettingHeader()}</div>
            <div style={SiteSettingsStyles.BodyStyle}>
                <p>{Messages.notifySiteAdminsOnThrottleSettingDescription()}</p>
                <CheckBoxWithLabelWidget
                    containerStyle={SiteSettingsStyles.CheckboxStyle}
                    checked={this.state.isEnabled}
                    handleChange={(checked: boolean) => {
                        // Annoyingly we have to modify the form object instead of being able to do stuff on save
                        // since we are called too late by the form service
                        this.props.siteAdminSettings.notifySiteAdminsOnThrottleEnabled = checked;
                        this.setState({
                            isEnabled: checked,
                        }, () => {
                            // We then have to tell angular to actually check that the form changed
                            const context = ServiceLocator.getAngularActionContext();
                            context.scope.$apply();
                        });
                    }}
                    testId="notify-site-admins-on-throttle-checkbox"
                    label={Messages.notifySiteAdminsOnThrottleSettingLabel()}
                />
            </div>
        </>;
    }
}
